import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Events from './components/Events';
import SpecialEvent from './components/SpecialEvent';
import Certification from './components/Certification';
import News from './components/News';
import Gallery from './components/Gallery';
import ContactNumbers from './components/ContactNumbers';
import BranchAddresses from './components/BranchAddresses';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Modal from './components/Modal';
import FloatingParticles from './components/FloatingParticles';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [theme, setTheme] = useState('dark');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    // Load saved preferences
    const savedTheme = localStorage.getItem('theme') || 'dark';
    
    setTheme(savedTheme);
    
    document.documentElement.setAttribute('data-theme', savedTheme);
  }, []);

  const handleThemeToggle = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    document.documentElement.setAttribute('data-theme', newTheme);
  };

  const openModal = (content) => {
    setModalContent(content);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  return (
    <div className="App">
      <FloatingParticles />
      <Navbar 
        theme={theme}
        onThemeToggle={handleThemeToggle}
        openModal={openModal}
      />
      <Hero />
      <About />
      <Services openModal={openModal} />
      <Events />
      <SpecialEvent />
      <Certification />
      <News />
      <Gallery />
      <ContactNumbers />
      <BranchAddresses />
      <Contact />
      <Footer />
      
      {isModalOpen && (
        <Modal 
          isOpen={isModalOpen}
          onClose={closeModal}
          content={modalContent}
        />
      )}
      
      <ScrollToTop />
    </div>
  );
}

export default App;